import { Button, Card, CardActions, Chip, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { UserTutorBookingListItem } from '../../models/Tutor';

type Props = {
  bookings: UserTutorBookingListItem[];
  onOpen: (booking: UserTutorBookingListItem) => void;
  onCancel: () => void;
  formatWhen: (startTime: string, endTime: string) => string;
  formatAmount: (amount: number, currencyCode: string) => string;
};

export default function UserTutorSeriesBookingCard({
  bookings,
  onOpen,
  onCancel,
  formatWhen,
  formatAmount,
}: Props) {
  const { t } = useTranslation();
  const rep = bookings[0];
  const title = rep.tutorName?.trim() || t('userTutorBookings.tutorSession', 'Lesson');
  const total = bookings.reduce((sum, booking) => sum + booking.totalAmount, 0);

  return (
    <Card variant="outlined" sx={{ borderRadius: 2, height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Stack spacing={1.5} sx={{ p: 2, flex: 1 }}>
        <Chip
          size="small"
          color="warning"
          label={t('status.pending', 'Pending')}
          sx={{ alignSelf: 'flex-start' }}
        />
        <Typography variant="h6" sx={{ fontWeight: 700 }}>
          {title}
        </Typography>
        <Stack spacing={0.5}>
          {bookings.map((booking) => (
            <Button
              key={booking.id}
              variant="text"
              color="inherit"
              onClick={() => onOpen(booking)}
              sx={{ justifyContent: 'flex-start', textTransform: 'none', px: 1 }}
            >
              {formatWhen(booking.startTime, booking.endTime)}
            </Button>
          ))}
        </Stack>
        <Typography variant="caption" color="text.secondary">
          {t('roomBookingRequests.totalForSessions', 'Total for {{count}} sessions', {
            count: bookings.length,
          })}
        </Typography>
        <Typography variant="subtitle1" fontWeight={800}>
          {formatAmount(total, rep.currencyCode)}
        </Typography>
      </Stack>
      <CardActions sx={{ px: 2, pb: 2 }}>
        <Button variant="outlined" color="error" onClick={onCancel} fullWidth>
          {t('userTutorBookings.cancelAll', 'Cancel all')}
        </Button>
      </CardActions>
    </Card>
  );
}
